import { usePermissions } from '@ltvco/refresh-lib/ctx';
import { Box, Button, Stack, Text } from '@ltvco/refresh-lib/theme';
import { useSession } from '@ltvco/refresh-lib/v1';
import { useNavigate } from 'react-router-dom';

import { FreeUserRewardContainer } from './FreeUserRewardContainer';
import { PremiumUserRewardContainer } from './PremiumUserRewardContainer';

export const Rewards = () => {
  const { isPremiumFeatureAllowedForFreePlanUsers } = usePermissions();
  const {
    session: { account },
  } = useSession();
  const navigate = useNavigate();
  const cannotAccessRewards =
    !isPremiumFeatureAllowedForFreePlanUsers('rewards_access') &&
    account?.account?.subscription_info?.free_user;

  const redirectToRewards = () => {
    navigate('/dashboard/rewards');
  };

  return (
    <Stack
      direction="column"
      gap={2}
      justifyContent="space-between"
      alignItems="center"
    >
      <Box>
        <Text variant="h3" mb={2.5} mt={1.5}>
          Rewards
        </Text>
        {cannotAccessRewards ? (
          <FreeUserRewardContainer displayCTABanner={true} />
        ) : (
          <PremiumUserRewardContainer />
        )}
      </Box>
      <Button variant="contained" onClick={redirectToRewards} sx={{ px: 8 }}>
        See more rewards
      </Button>
    </Stack>
  );
};
